import React from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

import { PortalTakeABreak } from 'playup-web-core';

import useNotify from '../../../hooks/useNotify';
import appConfig from '../../../appConfig';
import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';
import { takeBreak } from '../../../api/users';
import { LoaderFixed } from '../../../components/Loader';

dayjs.extend(localizedFormat);
const isUS = appConfig.regions.isUS;

const TakeBreak = () => {
	const [errors, setErrors] = React.useState<APIError>();
	const [sending, setSending] = React.useState(false);
	const { user, logout } = React.useContext(PortalSessionContext);

	const history = useHistory();
	const notify = useNotify();

	const handleSubmit = (period: string) => {
		setSending(true);
		setErrors(undefined);
		takeBreak(period)
			.then(() => {
				notify({
					type: 'success',
					title: 'Success',
					message: `Your ${isUS ? 'timeout' : 'break'} request was applied.`,
					timeout: 5000,
				});
				logout();
				history.push('/');
			})
			.catch((error) => {
				setErrors(error.errors);
			})
			.finally(() => {
				setSending(false);
			});
	};

	if (!user) return <LoaderFixed />;

	return (
		<>
			<Helmet title={isUS ? 'Timeout' : 'Take a Break'} />
			<PortalTakeABreak
				brandName={appConfig.brand.name}
				user={user}
				sending={sending}
				errors={errors}
				handleSubmit={handleSubmit}
				isUS={isUS}
			/>
		</>
	);
};

export default TakeBreak;
